import { NestedField, useFieldValue } from "components/form/input/NestedField";
import React, { memo, useCallback, useMemo, useState } from "react";
import OkTable from ".";
import _ from "lodash";
import { Box } from "@mui/material";

const MemoCell = memo(({ orgCN, item, row, col, name }) => {
    return (
        <NestedField key={row} index={row} prefix={name}>
            <Box sx={{ display: "flex", flex: 1, p: "3px", backgroundColor: orgCN.backgroundColor }}>
                {orgCN.cell(item, row, col)}
            </Box>
        </NestedField>
    );
});

export default function OkTableFields({ name, columns, hideScrollbar, ...props }) {
    // console.log('OK TABLE FIELDS')
    const [perPage, setPerPage] = useState(5);
    const [currentPage, setCurrentPage] = useState(1);
    const [values] = useFieldValue(name);

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const handlePerRowsChange = async (newPerPage, page) => {
        setPerPage(newPerPage);
    };

    const renderCell = useCallback(
        (orgCN) => (item, row, col) => {
            let rowInValues = row;

            rowInValues = rowInValues + perPage * (currentPage - 1);
            return <MemoCell item={item} row={rowInValues} col={col} orgCN={orgCN} name={name} />;
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [name, perPage, currentPage]
    );

    const c = useMemo(() => {
        let newAr = [];
        columns.forEach((c) => {
            let newC = _.cloneDeep(c);
            newC.compact = "true";
            if (c.cell) {
                newC.cell = renderCell(c);
            }

            newAr.push(newC);
        });
        // console.log("newAr", newAr);
        // console.log('cols', columns)
        return newAr;
    }, [columns, renderCell]);

    return (
        <OkTable
            columns={c}
            data={values || []}
            {...props}
            onChangeRowsPerPage={handlePerRowsChange}
            onChangePage={handlePageChange}
            hideScrollbar={hideScrollbar}
        />
    );
}
